<template>
  <div>
    <please-wait-modal/>
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">{{ this.$route.query.id != null ? 'Edit' : 'Add' }} Health History</h1>
    </div>
    <div class="row">
      <div class="col-12 col-md-4 mt-2 d-none d-md-block">
        <ul class="list-group">
          <li class="list-group-item p-5">
            <div class="ratio_169" :style="{'backgroundImage':'url('+picture+')'}" style="background-repeat: no-repeat; background-size: contain;"></div>
            <input type="file" name="photo" accept="image/*" class="d-none" id="file_input" @change="display_image">
            <a name="uploadPhoto" id="uploadPhoto" class="btn btn-outline-primary mt-4 btn-block btn-sm" href="#!" role="button" onclick="$('#file_input').trigger('click')">Upload Photo</a>
          </li>
        </ul>
      </div>
      <div class="col">
        <div class="form-group">
          <div class="row px-3">
            <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Name</label>
            <input type="text" v-model="name" class="form-control" id="form-title"/>
          </div>
        </div>
        <div class="form-group">
          <div class="row px-3">
            <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Checkup Date</label>
            <div class="col-12 p-0">
              <v-date-picker v-model="checkup_date"
                locale="id-ID"
                :input-props='{
                  class: "form-control w-100",
                }'/>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row px-3">
            <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Notes</label>
            <textarea v-model="notes" class="form-control"></textarea>
          </div>
        </div>
        <div class="form-group text-right">
          <a type="button" class="btn btn-danger" :href="'/user/action?id='+user_id">Cancel</a>
          <button type="button" class="btn btn-primary" @click="save">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import please_wait_modal from '@/layout/please_wait_modal'

import DatePicker from 'v-calendar/lib/components/date-picker.umd'

export default {
  components:{
    'v-date-picker': DatePicker,
    'please-wait-modal': please_wait_modal,
  },
  data(){
    return{
      picture: '',
      checkup_date: '',
      name: '',
      notes: '',
      user_id: this.$route.query.user_id,
      is_change_photo: false,
    }
  },
  created(){
    if(this.$route.query.id != null){
      this.get_data()
    }
  },
  methods:{
    async save(){
      try{
        if(this.name == '')
          this.$toasted.show('Name is empty')
        else if(this.checkup_date == '')
          this.$toasted.show('Checkup date is empty')
        else if(this.picture == '')
          this.$toasted.show('Picture is empty')
        else{
          $('#please_wait_modal').modal('show')
          var data = {}
          if(this.$route.query.id != null)
            data.id = this.$route.query.id
          data.name = this.name
          data.checkup_date = moment(this.checkup_date).format('YYYY-MM-DD')
          data.notes = this.notes
          data.user_id = this.user_id
          if(this.is_change_photo)
            data.image = await image2base64(this.picture)

          if(this.$route.query.id == null)
            var response = await axios.post(base_url+'/health-history',data)
          else
            var response = await axios.put(base_url+'/health-history',data)

          $('#please_wait_modal').modal('hide')
          var response_data = response.data
          if(response_data.status == "success"){
            location.href = '/user/action?id='+this.user_id
          }
          else
            this.$toasted.show(response_data.message)
        }
      } catch(e){
        $('#please_wait_modal').modal('hide')
        this.$toasted.show(e.message)
      }
    },
    async get_data(){
      try{
        var response = await axios.get(base_url+'/health-history?id='+this.$route.query.id)

        var response_data = response.data
        if(response_data.status == "success"){
          this.name = response_data.data.name
          var moment_date = moment(response_data.data.checkup_date)
          // console.log(moment_date.format('DD/MM/YYYY'))
          this.checkup_date = new Date(moment_date.format('MM/DD/YYYY'))
          this.notes = response_data.data.notes
          this.picture = base_url+'/images/health-history?file_name='+response_data.data.file_name
          this.is_change_photo = false
          console.log(this.date)
        }
      } catch(e) {
        this.$toasted.show(e.message)
      }
    },
    display_image(e){
      this.picture = URL.createObjectURL(event.target.files[0])
      this.data_photo = event.target.files[0]
      this.is_change_photo = true
    },
  }
}
</script>
